import React from "react"

const ImgStandardSize = ({
  size = size
}) => {
  return <p className="standardsize">※ 画像の横幅規定サイズは{size}pxです。</p>
}

export default ImgStandardSize